export const POLICY_VERSIONS = Object.freeze({
  terms: "2026-07-30",
  privacy: "2026-07-30",
  communityGuidelines: "2026-07-30",
});

export function hasAcceptedCurrentPolicies(profileData) {
  const acceptance = profileData?.policyAcceptance;

  return (
    acceptance?.termsVersion === POLICY_VERSIONS.terms &&
    acceptance?.privacyVersion === POLICY_VERSIONS.privacy &&
    acceptance?.communityGuidelinesVersion ===
      POLICY_VERSIONS.communityGuidelines
  );
}
